/* (c) Copyright Frontify Ltd., all rights reserved. */

import * as ToolbarPrimitive from '@radix-ui/react-toolbar';

export const ToolbarWrapper = ToolbarPrimitive.Root;
